import { defineStore } from 'pinia'
import adminAPI from '@/services/api';

import {
  TenantDetails,
} from "@/interfaces/data-contracts";

const useClaimStore = defineStore("TenantStore", {
  state: () => {
    return {
      tenant: null as any as TenantDetails,
    }
  },
  actions: {
    async retrieveCurrentTenant() {
      const tenant = await adminAPI.retrieveCurrentTenant();
      this.tenant = tenant;
      return tenant;
    },
  }
});

export default useClaimStore;